// @vendors
const get = require('lodash/object/get');

// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');
const { OPEN_TRADER_URL_BASE } = require('constants/index');

const fetchLinkSuccess = openTraderLink => ({
    type: actionTypes.BROKER_OPEN_TRADER_FETCH_LINK_SUCCESS,
    payload: {
        openTraderLink
    }
});

const fetchLinkFailure = error => ({
    type: actionTypes.BROKER_OPEN_TRADER_FETCH_LINK_FAILURE,
    payload: {
        error
    }
});

const buildLink = () => (dispatch) => {
    const url = apiURLBuilder.getURL('investmentOpenTraderAcceso');

    return APIGet(dispatch, url, {}).then(response => {
        const key = get(response, 'key');
        const uid = get(response, 'uid');

        return `${OPEN_TRADER_URL_BASE}?key=${key}&uid=${uid}`;
    });
};

const openLink = () => dispatch => {
    dispatch(buildLink()).then(link => window.open(link, '_blank'));
};

const fetchLink = () => (dispatch, getState) => {
    const isFetched = getState().brokerOpenTrader.get('fetched');

    if (!isFetched) {
        dispatch(buildLink()).then(
            link => dispatch(fetchLinkSuccess(link)),
            error => dispatch(fetchLinkFailure(error))
        );
    }
};

module.exports ={
    fetchLink,
    openLink
};
